import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Certificacion } from 'src/app/interfaces/certificacion';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificacionService {

  private baseApiUrl = environment.baseApi + '/privado/certificacion';

  constructor(private httpClient: HttpClient) { }

  async obtenerCertificacionesPorIdCandidato(idCandidato: number){
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/${idCandidato}`).toPromise();
  }

  registrarCertificacion(idCandidato:number, body: Certificacion): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}/registrar/${idCandidato}`, body, { headers });
  }

  actualizarCertificaciones(idCandidato:number, body: Certificacion): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<Response>(`${this.baseApiUrl}/${idCandidato}/`, body, { headers });
  }

  eliminarCertificacionPorId(idCandidato: number, idCertificacion: number): Observable<Response> {
    return this.httpClient.delete<Response>(`${this.baseApiUrl}/${idCandidato}/${idCertificacion}`);
  }

}
